/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedOccupancyStatsResponseLeadsCountByBedTypeInner
 */
export interface BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    /**
     * Type of bed
     * @type {string}
     * @memberof BedOccupancyStatsResponseLeadsCountByBedTypeInner
     */
    bed_type: string;
    /**
     * Number of leads in this bed type
     * @type {number}
     * @memberof BedOccupancyStatsResponseLeadsCountByBedTypeInner
     */
    count: number;
}

/**
 * Check if a given object implements the BedOccupancyStatsResponseLeadsCountByBedTypeInner interface.
 */
export function instanceOfBedOccupancyStatsResponseLeadsCountByBedTypeInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bed_type" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSON(json: any): BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    return BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSONTyped(json, false);
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bed_type': json['bed_type'],
        'count': json['count'],
    };
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSON(value?: BedOccupancyStatsResponseLeadsCountByBedTypeInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bed_type': value.bed_type,
        'count': value.count,
    };
}

